<template>
  <h1>Ticket levels</h1>
</template>

<script>
export default {
  name: 'Levels',
  components: {},
  data () {
    return {
      tickets: [],
      page: 1,
      next: null,
      prev: null,
      count: null,
      searchTerm: '',
      fields: [],
      loading: false,
      initialLoad: false
    }
  },
  mounted () {},
  computed: {},
  watch: {},
  methods: {}
}
</script>
